import React from "react";
import PartyStatement from "./PartyStatement";

const SupplierPartyStatement = () => (
  <PartyStatement
    title="Supplier Party Statement"
    statementApi="GetDailySupplierSalesStatement"
    ledgerVtype="Supplier"
    csvPrefix="supplier-party-statement"
  />
);

export default SupplierPartyStatement;
